import React from 'react';
import { useEffect } from "react";
import {useTranslation} from 'react-i18next';
import Modal from '@components/modal/modal.component';
import {StyledModalContent} from '@components/modal/modal.style';
import Form from '@components/form';
import {StyledInput, StyledInputGroup, StyledInputUnit} from '@components/form/input/input.style';
import {StyledButton} from '@components/button/button.style';
import {StyledContent} from "./commentsModal.style";
import {ReportRowFile} from "@app/reportPage/reportPage.component";
import {Controller, useForm} from "react-hook-form";
import {IonCol} from "@ionic/react";

type FilenameEditForm = {
    filename: string,
}

type FilenameEditModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: string) => void;
    file: ReportRowFile,
};

const FilenameEditModal: React.FC<FilenameEditModalProps> = ({isOpen, onClose, onSubmit, file}: FilenameEditModalProps) => {
    const {t} = useTranslation();

    useEffect(() => {
        reset({ filename: extractFilename(file.original_name) });
    }, [isOpen]);

    const submitFilename = (data: FilenameEditForm) => {
        onSubmit(`${data.filename}.${extractExtension(file.original_name, file?.extension)}`);
        reset({filename: data.filename});
    }

    useEffect(() => {
        reset({ filename: extractFilename(file.original_name) });
    }, [isOpen]);

    const extractFilename = (filename: string) => {
        return filename.split('.').shift();
    }

    const extractExtension = (filename: string, extension?: string) => {
        if (extension) {
            return extension
        }

        return filename.split('.').pop();
    }

    const {control, handleSubmit, formState: {errors}, reset} = useForm<FilenameEditForm>({
        mode: 'onChange',
        defaultValues: {
            filename: extractFilename(file.original_name)
        },
    });

    return (
        <Modal
            isOpen={isOpen}
            disableClose={true}
            initialBreakpoint={0.5}
            breakpoints={[0, 0.5]}
            onDidDismiss={() => onClose()}
        >
            <Form.Container className="modalForm" onSubmit={handleSubmit(submitFilename)}>
                <StyledModalContent className="t-p-25">
                    <StyledContent className="content">
                        <div className="label">{t('reportPage.filenameEdit.title')}</div>
                        <StyledInputGroup unit={true}>
                            <IonCol size="10" className="label">
                                <Controller
                                    name="filename"
                                    control={control}
                                    rules={{required: true}}
                                    render={(field) => (
                                        <StyledInput
                                            {...field}
                                            placeholder={t("reportPage.filenameEdit.placeholder")}
                                            className={errors.filename ? 'error' : ''}
                                        />
                                    )}
                                />
                            </IonCol>
                            <IonCol size="2" className="label">
                                <StyledInputUnit>.{extractExtension(file.original_name, file?.extension)}</StyledInputUnit>
                            </IonCol>
                        </StyledInputGroup>

                        <StyledButton>{t('reportPage.filenameEdit.editButton')}</StyledButton>
                    </StyledContent>
                </StyledModalContent>
            </Form.Container>
        </Modal>
    );
};

export default FilenameEditModal;